module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAA2ElEQVR4AdSQuxGCQBRFYalCO4ALDViHY2IBlqGRsbGxkSSWYGJuwNqBlgHeC7vOCKg4RjL75n3P+2CCH74/g+M4Hunar9YGkKRpeoqi6Ea9GgwDSIwxe06cUPSWg2CgAauqgigJ7e1HGOiChHNr7cJo9yzLrtQ7AAkTjwf0g0VRzFRkwjCccoUxnbluApoGwHuQ9YEheJYhoQ3fQFq+4k5yP9H5NbzmdOsDAoaAqjc8/FKW5azdQEknnYkuHtR/u6+BK3gJKl/DMnwD2gfKkZts2jcy/vTuAAAA//9Jxm6vAAAABklEQVQDAGZdc1ZKUaCmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Y.png
// module id = gvcr
// module chunks = 1